<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="row">
  <div class="col-lg-12">
    <div class="px-3">
      @if (showSearchUI) {
        <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true [showDevelopments]=false
          [showShortTermRentals]=false [showYieldMaxProperties]=!propertyId [showRateBuckets]=false [showBedrooms]=true [showSeasons]=false
          [showReservationStatuses]=false [showStartDate]=true [showEndDate]=true [showSaleDateStart]=false
          [showSaleDateEnd]=false [defaultStartDate]="defaultStartDate" [showSaleYear]=false [displayRecordsOnPageLoad]="false"
          [defaultEndDate]="defaultEndDate" [showYieldMaxDevelopments]=true [defaultShortTermRentalIds]="defaultShortTermRentalIds"
          [yieldMaxSelectedProperty] = "propertyId" [yieldMaxSelectedStartDate] = "startDate" [yieldMaxSelectedEndDate] = "endDate"
          [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="onSearchSubmit($event)">
        </app-search-template>
      }
    </div>
  </div>
  <!-- <div class="col-lg-5 pt-4 1111">
  <p-button severity="secondary" label="Generate Rates" (click)="generateRates()" class="my-2 d-block"></p-button>
</div> -->
</div>

<p-table class="table-chart" #pt [value]="tapeChartsByProperty" [columns]="scrollingColumns" scrollDirection="both" [frozenWidth]="frozenWidth"
  [lazy]="false" dataKey="propertyCode" selectionMode="single"
  [scrollable]="true" [scrollHeight]="innerHeight +'px'"
  [(selection)]="tapeChart" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" groupRowsBy="propertyCode">

  <ng-template pTemplate="caption">
    <div class="d-flex text-end justify-content-between align-items-center">
      <h1 style="text-align: left; font-size: 1.5rem; margin-bottom: 0px;">Tape Chart</h1>
      <div class="legend-row">

        <div class="legend-container">
          <div class="legend-color" style="text-align: left; background-color: lightgreen"></div>
          <div class="legend-text">Available</div>
        </div>

        <div class="legend-container">
          <div class="legend-color" style="text-align: left; background-color: #DCD4D7"></div>
          <div class="legend-text">Guest</div>
        </div>

        <div class="legend-container">
          <div class="legend-color" style="text-align: left; background-color: #FF00CC;"></div>
          <div class="legend-text">Owner</div>
        </div>

        <div class="legend-container">
          <div class="legend-color" style="text-align: left; background-color: #FF00C0;"></div>
          <div class="legend-text">Owner Guest</div>
        </div>

        <div class="legend-container">
          <div class="legend-color" style="text-align: left; background-color: lightgrey;"></div>
          <div class="legend-text">Maintenance</div>
        </div>

        <div class="legend-container">
          <div class="legend-color" style="text-align: left; background-color: #FFFF00;"></div>
          <div class="legend-text">Hold</div>
        </div>
      </div>
      <!-- <p-button severity="secondary" label="Generate Rates for All Properties" (click)="generateRates()" class="my-2 mb-0 generate-btn d-block btn-secondary btn-warning-custom"></p-button> -->
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of frozenColumns; track col) {
        <th style="width:75px;height:115px;padding-left: 15px !important;"
          [pSortableColumn]="col.field" pFrozenColumn>
          <div class="d-flex flex-column">
            {{col.header}}
          </div>
        </th>
      }
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr class="ratetable">
      @for (col of frozenColumns; track col) {
        <td style="width:75px;height:140px; padding-left: 15px !important;"
          pFrozenColumn>
          {{rowData[col.field]}}
        </td>
      }
      @for (rate of rowData.rates; track rate) {
        @if (rate.isDateMatched) {
          @if (rate.isDateMatched) {
            <td
					[ngStyle]="rate.reservationId!=null?
					rate.reservationStatus=='H'?{'background-color':'#FFFF00'}:
					rate.reservationType=='OG'?{'background-color':'#FF00C0'}:
					rate.reservationType=='M'?{'background-color':'lightgrey'}:
					rate.reservationType=='O'?{'background-color':'#FF00CC'}:{'background-color':'#DCD4D7'}
					: {'background-color': 'lightgreen'}"
              >
              <tr (click)="editRateDetails(rate)">
                <div class="d-flex">
                  <div class="fixdata" title="Yielded Price AMT">
                    <b>{{calcYielPrice(rate) | currency : 'USD' : 'symbol' :
                    '1.0-0'}}</b>
                  </div>
                  <div class="fixdata fixdatalong" title="List Price AMT">{{calcListPrice(rate) | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
                  <div class="fixdata fixdatasmall" style="text-align: right !important; padding-right: 10px !important;" title="Bulk Update"><a href="javascript:void(0);" (click)="onGoToBulkUpdate(rate)">B</a></div>
                </div>
              </tr>
              <tr (click)="editRateDetails(rate)">
                <div class="d-flex">
                  @if (rate.listPriceAdjustAMT) {
                    <div class="fixdata" title="List Price Adj AMT">{{rate.listPriceAdjustAMT | currency :
                    'USD' : 'symbol' : '1.0-0'}}</div>
                  }
                  @if (!rate.listPriceAdjustAMT) {
                    <div class="fixdata" title="List Price Adj AMT"></div>
                  }
                  @if (rate.listPriceAdjustPCT) {
                    <div class="fixdata fixdatalong" title="List Price Adj PCT">{{rate.listPriceAdjustPCT | percent}}
                    ({{calcAmtFromListPriceAdjustPCT(rate) | currency : 'USD' : 'symbol' :'1.0-0'}}) </div>
                  }
                  @if (!rate.listPriceAdjustPCT) {
                    <div class="fixdata fixdatalong" title="List Price Adj PCT"> </div>
                  }
                  <div class="fixdata fixdatasmall"></div>
                </div>
              </tr >
              <tr (click)="editRateDetails(rate)">
                <div class="d-flex">
                  @if (rate.rateBucketAdjustmentPct) {
                    <div class="fixdata" title="Rate Bucke Adj %">
                      {{rate.rateBucketAdjustmentPct | percent}} ({{calcAmtFromRateBucketAdjustmentPct(rate) | currency :
                      'USD' : 'symbol' :'1.0-0'}})
                    </div>
                  }
                  @if (!rate.rateBucketAdjustmentPct) {
                    <div class="fixdata " title="Rate Bucke Adj %">
                    </div>
                  }
                  @if (rate.floorRateManagerAMT) {
                    <div class="fixdata fixdatalong" title="Mgr Floor AMT">
                      {{rate.floorRateManagerAMT | currency : 'USD' : 'symbol' :
                      '1.0-0'}} |
                      @if (rate.minNightlyRate) {
                        <span title="Property Floor AMT">
                          {{rate.minNightlyRate | currency : 'USD' : 'symbol' :
                        '1.0-0'}}</span>
                      }
                      @if (rate.floorRateOwnerAMT) {
                        <span title="Owner Floor AMT">
                          | {{rate.floorRateOwnerAMT | currency : 'USD' : 'symbol' :
                          '1.0-0'}}
                        </span>
                      }
                    </div>
                  }
                  @if (!rate.floorRateManagerAMT) {
                    <div class="fixdata fixdatalong" title="Mgr Floor AMT"></div>
                  }
                  <div class="fixdata fixdatasmall"></div>
                </div>
              </tr>
              <tr (click)="editRateDetails(rate)">
                <div class="d-flex">
                  @if (rate.maxDiscountPCT) {
                    <div class="fixdata " title="Max Discount %">{{rate.maxDiscountPCT | percent}}
                    ({{calcAmtFromMaxDiscountPCT(rate) | currency : 'USD' : 'symbol' :'1.0-0'}})</div>
                  }
                  @if (!rate.maxDiscountPCT) {
                    <div class="fixdata " title="Max Discount %"></div>
                  }
                  @if (rate.discountLookForwardDays) {
                    <div class="fixdata fixdatalong" title="Discount Look Forward Days">
                    {{rate.discountLookForwardDays}}d</div>
                  }
                  @if (!rate.discountLookForwardDays) {
                    <div class="fixdata fixdatalong" title="Discount Look Forward Days"></div>
                  }
                  <div class="fixdata fixdatasmall"></div>
                </div>
              </tr>
              @if (rate.reservationId) {
                <tr>
                  <div class="d-flex">
                    <div class="fixdata" title="Check In Date">{{rate.checkInDate | date:'MM-dd'}} @if (rate.checkOutDate) {
                      <span title="Check Out Date"> {{rate.checkOutDate | date:'MM-dd'}}</span>
                      }  @if (rate.numNights) {
                      <span title="Nights">({{rate.numNights}})</span>
                    }</div>
                    <div class="fixdata fixdatalong" (click)="openReservation(rate)"><a href="javascript:void(0);">{{rate.lastname}}</a></div>
                    <div class="fixdata fixdatasmall"></div>
                  </div>
                </tr>
              }
              @if (!rate.reservationId) {
                <tr (click)="editRateDetails(rate)">
                  <div class="d-flex">
                    <div class="fixdata" title="Check In Date"> </div>
                    <div class="fixdata fixdatalong" ><a href="javascript:void(0);"></a></div>
                    <div class="fixdata fixdatasmall"></div>
                  </div>
                </tr>
              }
            </td>
          }
          @if (!rate.isDateMatched) {
            <td>{{rate.isDateMatched}}</td>
          }
        }
      }
    </tr>
  </ng-template>
</p-table>

